import React, { useContext, useEffect, useMemo } from "react";
import { MediaItem, deleteMedia, renameMedia } from "./media-api";
import { formatDatetime } from "simple-utils/dist/date-utils";
import { useConfirm, usePrompt } from "../components/Dialogs";
import { MediaContext } from "./media-store";
import { useModalHide } from "../components/Modal";
import { memorySize } from "simple-utils";


export function MediaPreviewBox({media, short = false}:{media:MediaItem, short?:boolean}){
    if(media.mimetype.startsWith("image"))
        return <div className="text-center">
            <img className="img-fluid rounded-2" style={ short ? {maxHeight: '120px'} : {}} src={media.url} />
        </div>

    if(media.mimetype.startsWith("audio"))  
        return <div className="text-center">
                <audio controls>
                    <source src={media.url} type={media.mimetype}></source>
                </audio>
        </div>
    
    return <div className="text-center">
        <a download={media.name} href={media.url} className="btn btn-primary"><i className="fa fa-download"></i> Download</a>
        
    </div>
}


export function MediaPreviewModal({media}:{media:MediaItem}){
    const prompt = usePrompt("Renomei o arquivo:", {ok: "Renomear", placeholder: "Nome do arquivo...", value: media.name});
    const confirm = useConfirm(<>Deseja deletar este arquivo: <b>{media.name}</b>?</>, {ok: "Remover", buttonClass:"btn btn-danger"})
    const {dispatch, state: {mediaList}} = useContext(MediaContext);
    const hide = useModalHide();
    
    async function rename(){
        var newName = await prompt();
        if(newName){
            await renameMedia(media.id, newName);
            dispatch({type: 'rename', payload:{media, newName}})
        }
    }

    async function remove(){
        var ok = await confirm();
        if(ok){
            await deleteMedia(media.id)
            await hide();
            dispatch({type: 'setList', payload: mediaList.filter(m => m.id != media.id)})
        }
    }

    return <>
        <div className="d-lg-flex align-items-end">
            <div className="flex-grow-1">
                <b>Arquivo:</b> {media.name} <a className="ms-2 btn-link" onClick={rename}><i className="fa fa-edit"></i></a> <br />
                <b>Tamanho:</b> {memorySize(media.size)} <br />
                <b>Criado em: </b> {formatDatetime(media.created)} 
            </div>
            <a className="btn btn-danger ms-lg-2 mt-2" onClick={() => remove()}><i className="fa fa-trash"></i></a>

        </div>
        <hr />
        <MediaPreviewBox media={media} />
    </>
}